import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/incoming_calls/index.vue'

export default class extends Controller {
  connect() {
    const props = {}

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
